import { Component } from '@angular/core'
import { ThemeService } from '@app/theme.service'
import { TranslateService } from '@ngx-translate/core'
import { MenuModel } from './models/menu.model'
import { MenuService } from './service/admin/menu.service'
import { PermissionService } from 'projects/vss-ui/src/vss-ui/modules/permission/permission.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'VTPost Quản lý tài sản';
  // userMenus: MenuModel[] = [
  //   {
  //     'icon': 'icons:dashboard',
  //     'iconActive': 'icons:dashboard',
  //     'id': '0',
  //     'level': 0,
  //     'title': 'Dashboard',
  //     'titleKey': 'Dashboard',
  //     'url': '/dashboard',
  //     roles: [],
  //     'children': [
  //       {
  //         'id': '5.1',
  //         'level': 1,
  //         'title': 'Dashboard',
  //         'titleKey': 'Dashboard',
  //         'url': '/dashboard',
  //         roles: [],
  //         'children': []
  //       },
  //     ]
  //   },
  //   {
  //     'icon': 'icons:category',
  //     'iconActive': 'icons:category',
  //     'id': '1',
  //     'level': 0,
  //     'title': 'MENU.CATEGORY_MANAGEMENT',
  //     'titleKey': 'MENU.CATEGORY_MANAGEMENT',
  //     'url': '/category-management/coach-position-category',
  //     roles: [],
  //     'children': [
  //       {
  //         'id': '1.1',
  //         'level': 1,
  //         'title': 'CATEGORY_MANAGEMENT.COACH_POSITION.TITLE',
  //         'titleKey': 'CATEGORY_MANAGEMENT.COACH_POSITION.TITLE',
  //         'url': '/category-management/coach-position-category',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '1.2',
  //         'level': 1,
  //         'title': 'CATEGORY_MANAGEMENT.CATEGORY_ACADEMIC_YEAR.TITLE',
  //         'titleKey': 'CATEGORY_MANAGEMENT.CATEGORY_ACADEMIC_YEAR.TITLE',
  //         'url': '/category-management/category-academic-years',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '1.3',
  //         'level': 1,
  //         'title': 'CATEGORY_MANAGEMENT.TOURNAMENT.TITLE',
  //         'titleKey': 'CATEGORY_MANAGEMENT.TOURNAMENT.TITLE',
  //         'url': '/category-management/tournament',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '1.4',
  //         'level': 1,
  //         'title': 'CATEGORY_MANAGEMENT.PLAYER_POSITIONS.TITLE',
  //         'titleKey': 'CATEGORY_MANAGEMENT.PLAYER_POSITIONS.TITLE',
  //         'url': '/category-management/player-positions',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '1.5',
  //         'level': 1,
  //         'title': 'CATEGORY_MANAGEMENT.PERFORMANCE_METRICS.TITLE',
  //         'titleKey': 'CATEGORY_MANAGEMENT.PERFORMANCE_METRICS.TITLE',
  //         'url': '/category-management/performance-metric',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '1.6',
  //         'level': 1,
  //         'title': 'CATEGORY_MANAGEMENT.AWARD.TITLE',
  //         'titleKey': 'CATEGORY_MANAGEMENT.AWARD.TITLE',
  //         'url': '/category-management/award',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '1.7',
  //         'level': 1,
  //         'title': 'CATEGORY_MANAGEMENT.PERFORMANCE_METRIC_GROUPS.TITLE',
  //         'titleKey': 'CATEGORY_MANAGEMENT.PERFORMANCE_METRIC_GROUPS.TITLE',
  //         'url': '/category-management/performance-metric-groups',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '1.8',
  //         'level': 1,
  //         'title': 'CATEGORY_MANAGEMENT.LESSON.TITLE',
  //         'titleKey': 'CATEGORY_MANAGEMENT.LESSON.TITLE',
  //         'url': '/category-management/lesson',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '1.9',
  //         'level': 1,
  //         'title': 'CATEGORY_MANAGEMENT.PLAYER_STATS.TITLE',
  //         'titleKey': 'CATEGORY_MANAGEMENT.PLAYER_STATS.TITLE',
  //         'url': '/category-management/player-stats',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '1.10',
  //         'level': 1,
  //         'title': 'CATEGORY_MANAGEMENT.CULTURAL_PROGRAM.TITLE',
  //         'titleKey': 'CATEGORY_MANAGEMENT.CULTURAL_PROGRAM.TITLE',
  //         'url': '/category-management/cultural-program',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '1.11',
  //         'level': 1,
  //         'title': 'CATEGORY_MANAGEMENT.CATAPULT.TITLE',
  //         'titleKey': 'CATEGORY_MANAGEMENT.CATAPULT.TITLE',
  //         'url': '/category-management/catapult',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '1.12',
  //         'level': 1,
  //         'title': 'CATEGORY_MANAGEMENT.WEEKLY_PLAN.TITLE',
  //         'titleKey': 'CATEGORY_MANAGEMENT.WEEKLY_PLAN.TITLE',
  //         'url': '/category-management/weekly-plan',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '1.13',
  //         'level': 1,
  //         'title': 'CATEGORY_MANAGEMENT.CLUB.TITLE',
  //         'titleKey': 'CATEGORY_MANAGEMENT.CLUB.TITLE',
  //         'url': '/category-management/club',
  //         roles: [],
  //         'children': []
  //       }
  //     ]
  //   },
  //   {
  //     // 'icon': 'icons:school',
  //     // 'iconActive': 'icons:school-inactive',
  //     'icon': 'icons:training',
  //     'iconActive': 'icons:training',
  //     'id': '3',
  //     'level': 0,
  //     'title': 'MENU.TRAINING_MANAGEMENT',
  //     'titleKey': 'MENU.TRAINING_MANAGEMENT',
  //     'url': '/training/cultural-learning-point',
  //     roles: [],
  //     'children': [
  //       {
  //         'id': '3.1',
  //         'level': 1,
  //         'title': 'TRAINING_MANAGEMENT.CULTURAL_LEARNING_POINT.TITLE',
  //         'titleKey': 'TRAINING_MANAGEMENT.CULTURAL_LEARNING_POINT.TITLE',
  //         'url': '/training/cultural-learning-point',
  //         roles: [],
  //         'children': [

  //         ]
  //       },
  //       {
  //         'id': '3.2',
  //         'level': 1,
  //         'title': 'TRAINING_MANAGEMENT.GOAL_MANAGEMENT.TITLE',
  //         'titleKey': 'TRAINING_MANAGEMENT.GOAL_MANAGEMENT.TITLE',
  //         'url': '/training/goal-management',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '3.4',
  //         'level': 1,
  //         'title': 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.TITLE',
  //         'titleKey': 'TRAINING_MANAGEMENT.QUALIFICATION_TEST.TITLE',
  //         'url': '/training/qualification-test',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '3.6',
  //         'level': 1,
  //         'title': 'TRAINING_MANAGEMENT.PROFESSIONAL_TRAINING_CLASS.TITLE',
  //         'titleKey': 'TRAINING_MANAGEMENT.PROFESSIONAL_TRAINING_CLASS.TITLE',
  //         'url': '/training/professional-traning-class',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '3.5',
  //         'level': 1,
  //         'title': 'ATTENDANCE_SUMMARY.MANAGER',
  //         'titleKey': 'ATTENDANCE_SUMMARY.MANAGER',
  //         'url': '/training/attendance-summary',
  //         roles: [],
  //         'children': []
  //       }
  //     ]
  //   },
  //   {
  //     // 'icon': 'icons:users',
  //     // 'iconActive': 'icons:users',
  //     'icon': 'icons:user-group-regular-full',
  //     'iconActive': 'icons:user-group-regular-full',
  //     'id': '4',
  //     'level': 0,
  //     'title': 'MENU.HUMAN_RESOURCE_MANAGEMENT',
  //     'titleKey': 'MENU.HUMAN_RESOURCE_MANAGEMENT',
  //     'url': '/user/player-acquisition',
  //     roles: [],
  //     'children': [
  //       {
  //         'id': '4.1',
  //         'level': 1,
  //         'title': 'PLAYER_ACQUISITION.TITLE',
  //         'titleKey': 'PLAYER_ACQUISITION.TITLE',
  //         'url': '/user/player-acquisition',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '4.2',
  //         'level': 1,
  //         'title': 'PLAYER_MANAGE.MANAGER',
  //         'titleKey': 'PLAYER_MANAGE.MANAGER',
  //         'url': '/user/player-manage',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '4.3',
  //         'level': 1,
  //         'title': 'COACH_MANAGE.MANAGER',
  //         'titleKey': 'COACH_MANAGE.MANAGER',
  //         'url': '/user/coach-manage',
  //         roles: [],
  //         'children': []
  //       }
  //     ]
  //   },
  //   {
  //     // 'icon': 'icons:users',
  //     // 'iconActive': 'icons:users',
  //     'icon': 'icons:truck-medical-regular-full',
  //     'iconActive': 'icons:truck-medical-regular-full',
  //     'id': '5',
  //     'level': 0,
  //     'title': 'MENU.HEALTH_MANAGEMENT',
  //     'titleKey': 'MENU.HEALTH_MANAGEMENT',
  //     'url': '/healthcare/routine-medical-check-up',
  //     roles: [],
  //     'children': [
  //       {
  //         'id': '5.1',
  //         'level': 1,
  //         'title': 'ROUTINE_MEDICAL_CHECK_UP.TITLE',
  //         'titleKey': 'ROUTINE_MEDICAL_CHECK_UP.TITLE',
  //         'url': '/healthcare/routine-medical-check-up',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '5.2',
  //         'level': 1,
  //         'title': 'INJURY.TITLE',
  //         'titleKey': 'INJURY.TITLE',
  //         'url': '/healthcare/injury',
  //         roles: [],
  //         'children': []
  //       }
  //     ]
  //   },
  //   {
  //     'icon': 'icons:futbol-light-full',
  //     'iconActive': 'icons:futbol-light-full',
  //     'id': '6',
  //     'level': 0,
  //     'title': 'MENU.COMPETITION_MANAGEMENT',
  //     'titleKey': 'MENU.COMPETITION_MANAGEMENT',
  //     'url': '/competition/match',
  //     roles: [],
  //     'children': [
  //       {
  //         'id': '5.1',
  //         'level': 1,
  //         'title': 'MATCH.TITLE',
  //         'titleKey': 'MATCH.TITLE',
  //         'url': '/competition/match',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '5.2',
  //         'level': 1,
  //         'title': 'FOOTBALL_TEAM.MANAGER',
  //         'titleKey': 'FOOTBALL_TEAM.MANAGER',
  //         'url': '/competition/team',
  //         roles: [],
  //         'children': []
  //       }
  //     ]
  //   },
  //   {
  //     'icon': 'icons:star',
  //     'iconActive': 'icons:star',
  //     'id': '6',
  //     'level': 0,
  //     'title': 'REWARD.MANAGER',
  //     'titleKey': 'REWARD.MANAGER',
  //     'url': '/reward/reward-management',
  //     roles: [],
  //     'children': [
  //       {
  //         'id': '6.1',
  //         'level': 1,
  //         'title': 'REWARD.MANAGER',
  //         'titleKey': 'REWARD.MANAGER',
  //         'url': '/reward/reward-management',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '6.2',
  //         'level': 1,
  //         'title': 'DISCIPLINE.MANAGER',
  //         'titleKey': 'DISCIPLINE.MANAGER',
  //         'url': '/reward/discipline-management',
  //         roles: [],
  //         'children': []
  //       }
  //     ]
  //   },
  //   {
  //     'icon': 'icons:settings',
  //     'iconActive': 'icons:settings',
  //     'id': '2',
  //     'level': 0,
  //     'title': 'MENU.SYSTEM_MANAGEMENT',
  //     'titleKey': 'MENU.SYSTEM_MANAGEMENT',
  //     'url': '/admin-management/system-parameters',
  //     roles: [],
  //     'children': [
  //       {
  //         'id': '2.1',
  //         'level': 1,
  //         'title': 'SYSTEM_PARAMETER.NAME',
  //         'titleKey': 'SYSTEM_PARAMETER.NAME',
  //         'url': '/admin-management/system-parameters',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '2.2',
  //         'level': 1,
  //         'title': 'PERMISSION_GROUP.MANAGER',
  //         'titleKey': 'PERMISSION_GROUP.MANAGER',
  //         'url': '/admin-management/permission-group',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '2.3',
  //         'level': 1,
  //         'title': 'USER_MAGAGEMENT.MANAGER',
  //         'titleKey': 'USER_MAGAGEMENT.MANAGER',
  //         'url': '/admin-management/user-manage',
  //         roles: [],
  //         'children': []
  //       },
  //       {
  //         'id': '2.4',
  //         'level': 1,
  //         'title': 'DATA_PERMISSION.MANAGER',
  //         'titleKey': 'DATA_PERMISSION.MANAGER',
  //         'url': '/admin-management/data-permission',
  //         roles: [],
  //         'children': []
  //       }
  //     ]
  //   },
  // ]

  constructor(
    private themeService: ThemeService,
    public translate: TranslateService,
    private permissionService: PermissionService
  ) {
    // Translation is now initialized in APP_INITIALIZER
    // this.translate.use(localStorage.getItem('language') || 'vi')
    // this.permissionService.menuObs.next(this.userMenus)
  }

  toggleTheme(): void {
    this.themeService.toggleTheme().then()
  }
}
